const { formatNumberWithCommas, currencyExchange } = window.BAO.Utils

class ExternalKlevuPriceFilter extends window.BAO.CustomElement({
  SuperClass: HTMLFormElement,
}) {
  constructor () {
    super()

    const source = window.theme.category || window.theme.searchResults
    this.state = {
      root: source ? source.stateLayer.state : undefined,
      facets: [],
    }

    this.eventBus = source ? source.eventBus : undefined

    if (!this.eventBus) {
      console.error('Event bus not available for FacetsTablet')
    }
    if (this.state.root === undefined) {
      console.error('State root not available for FacetsTablet')
    }

    this._FACET_KEYS = Object.freeze({
      PRICE: 'klevu_price',
      TYPE: 'type',
      GENDER: 'gender',
      BRAND: 'brand',
      TAGS: 'tags',
      CONTACT_US: 'contact_us',
      BACK_IN_STOCK: 'back_in_stock',
      COMING_SOON: 'coming_soon',
    })
  }

  connectedCallback () {
    super.connectedCallback()

    this.subscribeToEvents()
  }

  /**
   * Subscribes to relevant events, primarily for facet data updates.
   */
  subscribeToEvents () {
    if (!this.eventBus) return

    let hasRendered = false

    this.eventBus.subscribe('api:facets:fetched', response => {
      this._processFetchedFacets(response)

      if (!hasRendered) {
        this._renderInitialFacets()
        hasRendered = true
      }
    })
  }

  /**
   * Processes the facet data received from the API.
   * @private
   * @param {Array<Object>} response - The array of facet objects from the API.
   */
  _processFetchedFacets (response) {
    this.state.facets = Array.isArray(response) ? response : []
  }

  /**
   * Renders the initial set of facets into the DOM.
   * This method is typically called once after the first batch of facet data is fetched.
   * @private
   */
  _renderInitialFacets () {
    this.state.facets.forEach((facet, index) => {
      if (facet.key === this._FACET_KEYS.PRICE) {
        const priceGiftContainerHtml = this.buildExternalPriceHTML(facet, index)
        this.insertAdjacentHTML('beforeend', priceGiftContainerHtml)
      }
    })
  }

  buildExternalPriceHTML (facet, index) {
    const existingFacetIndex = this.state.root.activeFacets.findIndex(
      activeFacet => activeFacet.key === 'klevu_price',
    )

    const currentMinFacet = currencyExchange(
      this.state.root.activeFacets[existingFacetIndex]?.values[0],
      false,
    )
    const currentMaxFacet = currencyExchange(
      this.state.root.activeFacets[existingFacetIndex]?.values[1],
      true,
    )

    const minValueInt = facet.min

    let maxValueInt = facet.max
    let maxValue = currencyExchange(maxValueInt, true)
    let suffix = ''
    const actualMaxValue = facet.max

    if (maxValue > parseInt(this.dataset.maxPrice)) {
      maxValueInt = parseInt(this.dataset.maxPrice)
      maxValue = maxValueInt
    }

    const minValue = currencyExchange(minValueInt, false)

    const currentMinValue =
      currentMinFacet && Number(currentMinFacet) >= Number(minValue)
        ? currentMinFacet
        : minValue

    const currentMaxValue =
      currentMaxFacet && Number(currentMaxFacet) <= Number(maxValueInt)
        ? currentMaxFacet
        : maxValue

    let currentMaxInputValue = maxValue

    if (maxValue >= parseInt(this.dataset.maxPrice)) {
      suffix = '+'
      currentMaxInputValue = ''
    }

    const currencySymbol = window.theme.moneyFormat.split('{')[0]
    return `
      <div data-filter-facet-search-external-el="body" data-range-slider-external-el="container">
        <price-range class="prc-Range prc-Range-external">
          <div class="prc-Range_Column">
            <div class="prc-Range_Field">
              <input class="prc-Range_Input" id="price-range-min" type="text" value="${formatNumberWithCommas(
                currentMinValue,
              )}" data-range-slider-external-el="min" placeholder="${currencySymbol}${formatNumberWithCommas(
      currentMinValue,
    )}" data-range-min="${minValue}" data-range-max="${maxValue}" data-price-range-el="min" />

              <label class="prc-Range_Label" for="price-range-min" data-currency-symbol="${currencySymbol}" data-text="${currencySymbol}${formatNumberWithCommas(
      currentMinValue,
    )}">
                <span class="util-ScreenReaderOnly">
                  {{ 'sections.collection_template.from' | t }}:
                  {{ cart.currency.symbol }}${formatNumberWithCommas(
                    currentMinValue,
                  )}</span>
              </label>
            </div>
          </div>

          <div class="prc-Range_Column prc-Range_Column-range">
            <range-slider
              class="rng-Slider"
              min="${minValue}"
              max="${maxValue}"
              min-value="${currentMinValue}"
              max-value="${currentMaxValue}">
              <div class="rng-Slider_Inner">
                <button
                  class="rng-Slider_Dot rng-Slider_Dot-left"
                  type="button"
                  data-range-slider-el="touchLeft">
                  <span class="rng-Slider_DotInner"></span>
                </button>

                <button
                  class="rng-Slider_Dot rng-Slider_Dot-right"
                  type="button"
                  data-range-slider-el="touchRight"
                  style="right: 0%;">
                  <span class="rng-Slider_DotInner"></span>
                </button>

                <div class="rng-Slider_Line" data-range-slider-el="line">
                  <span class="rng-Slider_LineInner"></span>
                  <span class="rng-Slider_LineHighlighter" data-range-slider-el="highlighter"></span>
                </div>
              </div>
            </range-slider>

          </div>

          <div class="prc-Range_Column">
            <div class="prc-Range_Field">
              <input class="prc-Range_Input" id="price-range-max" type="text" data-range-slider-external-el="max" placeholder="${currencySymbol}${formatNumberWithCommas(
      currentMaxValue,
    )}" data-range-max="${maxValue}" data-max-reached-limit="${
      this.dataset.maxPrice
    }" data-max-reached-int="${actualMaxValue}" data-price-range-el="max" value="${currentMaxInputValue}"/>

              <label class="prc-Range_Label" for="price-range-max" data-range-slider-external-el="maxLabel" data-currency-symbol="${currencySymbol}" data-text="${currencySymbol}${formatNumberWithCommas(
      currentMaxValue,
    )}${suffix}">
                <span class="util-ScreenReaderOnly">
                  {{ 'sections.collection_template.to' | t }}:
                  {{ cart.currency.symbol }}${formatNumberWithCommas(
                    currentMaxValue,
                  )}</span>
              </label>
            </div>
          </div>
        </price-range>
      </div>
    `
  }
}

if (!window.customElements.get('external-klevu-price-filter')) {
  window.customElements.define(
    'external-klevu-price-filter',
    ExternalKlevuPriceFilter,
    {
      extends: 'form',
    },
  )
}
